// AUTO-GENERATED by sync-icons — do not edit.
import CheckIconSvg from './CheckIcon';
import CloseIconSvg from './CloseIcon';
import HomeIconSvg from './HomeIcon';
import MobileIconSvg from './MobileIcon';
import SettingBarsIconSvg from './SettingBarsIcon';
import SettingsIconSvg from './SettingsIcon';
import VisibilityIconSvg from './VisibilityIcon';
import VisibilityOffIconSvg from './VisibilityOffIcon';
import { withIconWrapper } from '../../IconWrapper';
export const CheckIcon = withIconWrapper(CheckIconSvg);
export const CloseIcon = withIconWrapper(CloseIconSvg);
export const HomeIcon = withIconWrapper(HomeIconSvg);
export const MobileIcon = withIconWrapper(MobileIconSvg);
export const SettingBarsIcon = withIconWrapper(SettingBarsIconSvg);
export const SettingsIcon = withIconWrapper(SettingsIconSvg);
export const VisibilityIcon = withIconWrapper(VisibilityIconSvg);
export const VisibilityOffIcon = withIconWrapper(VisibilityOffIconSvg);
